import { findAll } from "../utils/dom";


const TelefoneAjuste = () =>{

	const $ = {
		telefones: findAll('[js-telefone]')
	}


	$.telefones?.forEach((telefone)=>{
		const numero = telefone.innerText;
		const result = numero.replaceAll(" ","").replaceAll("(","").replaceAll(")","").replaceAll("-","");

		telefone.setAttribute("href",`tel:${result}`);
	})
}

export default TelefoneAjuste;